<template>
  <div class="parent_note">
    <img v-if="data.note" v-for="k in data.note" :src="k" />
    <p @click="go_native">进入下一步学习</p>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/lightAjax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/fit_iphonex/lesson_loading_fit_iphonex.vue";
export default {
  name: "parent_note",
  data() {
    return {
      token: "",
      sectionId: "",
      data: {},
      orderId: "",
      loadingLock: true,
      status: "loading"
    };
  },
  methods: {
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/light/section/parent-note", {
          params: {
            token: self.token,
            sectionId: self.sectionId
          }
        })
      ]);
      console.log(resp.data.data);
      if (resp.data.code == 99999) {
        this.loadingLock = false;
        this.data = resp.data.data;
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    go_native() {
      window.location = "hybird://method/continueNextLightCourseStudyFlow";
    }
  },
  components: {
    lesson_loading
  },
  created: async function() {
    let self = this;
    self.token = utils.getQueryString("token");
    self.sectionId = utils.getQueryString("sectionId");
    self.initData();
  }
};
</script>

<style scoped lang="scss">
.parent_note {
  background: #fff;
  &:before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
    background-color: #fff;
    z-index: 9998;
  }
  img {
    width: 100%;
  }
  p {
    position: fixed;
    bottom: 0.56rem;
    left: 0;
    right: 0;
    margin: auto;
    width: 5.2rem;
    height: 1rem;
    line-height: 1rem;
    background-color: #43a5f3;
    border-radius: 0.5rem;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #ffffff;
    text-align: center;
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .parent_note {
    padding-top: constant(safe-area-inset-top);
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .parent_note {
    padding-top: constant(safe-area-inset-top);
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .parent_note {
    padding-top: constant(safe-area-inset-top);
  }
}
</style>